import { render, staticRenderFns } from "./stadiumType.vue?vue&type=template&id=34105c93&scoped=true"
import script from "./stadiumType.vue?vue&type=script&lang=js"
export * from "./stadiumType.vue?vue&type=script&lang=js"
import style0 from "./stadiumType.vue?vue&type=style&index=0&id=34105c93&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34105c93",
  null
  
)

export default component.exports